import { Box, Button, Typography } from '@material-ui/core'
import React from 'react'
import MoonMan from './images/MoonMan'

const LocationUnsupported = () => {
  return (
    <Box textAlign="center">
      <Typography variant="h4">Your location is not yet supported by Foodsby...</Typography>

      <MoonMan width="300px" height="400px" />
      <Typography variant="subtitle2">Not satisfied? Send us a message...</Typography>
      <Box mt={3}>
        <Button component="a" href="mailto:support@foodsby.com" variant="contained" color="primary">
          Email Foodsby
        </Button>
      </Box>
    </Box>
  )
}

export default LocationUnsupported
